import { Checkbox as CK } from "@rmwc/checkbox";

import "@rmwc/checkbox/styles";
import "./Checkbox.css";

export const Checkbox = CK;
